import palette from './palette';

export default {
  h1: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: 'min(5vw, 26px)',
    letterSpacing: '-0.24px',
    lineHeight: 'min(5.5vw, 28px)',
  },
  h2: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: 'min(4vw, 22px)',
    letterSpacing: '-0.24px',
    lineHeight: 'min(4.5vw, 24px)',
  },
  h3: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: 'min(3.5vw, 18px)',
    letterSpacing: '-0.06px',
    lineHeight: 'min(4vw, 20px)',
  },
  h4: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: 'min(3vw, 16px)',
    letterSpacing: '-0.06px',
    lineHeight: 'min(3.5vw, 18px)',
  },
  h5: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: 'min(2.5vw, 12px)',
    letterSpacing: '-0.05px',
    lineHeight: 'min(3vw, 14px)',
  },
  h6: {
    color: palette.text.primary,
    fontWeight: 500,
    fontSize: 'min(2vw, 10px)',
    letterSpacing: '-0.05px',
    lineHeight: 'min(2.5vw, 12px)',
  },
  subtitle1: {
    color: palette.text.primary,
    fontSize: 'min(2vw, 14px)',
    letterSpacing: '-0.05px',
    lineHeight: 'min(2.5vw, 15px)',
  },
  subtitle2: {
    color: palette.text.secondary,
    fontWeight: 400,
    fontSize: 'min(2vw, 14px)',
    letterSpacing: '-0.05px',
    lineHeight: 'min(2.5vw, 15px)',
  },
  body1: {
    color: palette.text.primary,
    fontSize: 'min(3.5vw, 18px)',
    letterSpacing: '-0.05px',
    lineHeight: 'min(4vw, 19px)',
  },
  body2: {
    color: palette.text.secondary,
    fontSize: 'min(3vw, 12px)',
    letterSpacing: '-0.04px',
    lineHeight: 'min(3.5vw, 14px)',
  },
  button: {
    color: palette.text.primary,
    fontSize: 'min(2.5vw, 14px)',
    lineHeight: 'min(3vw, 16px)',
  },
  caption: {
    color: palette.text.secondary,
    fontSize: 'min(2.5vw, 11px)',
    letterSpacing: '0.33px',
    lineHeight: 'min(3vw, 14px)',
  },
  overline: {
    color: palette.text.secondary,
    fontSize: 'min(2.2vw, 12px)',
    fontWeight: 500,
    letterSpacing: '0.33px',
    lineHeight: 'min(2.5vw, 13px)',
    textTransform: 'uppercase',
  },
  whiteText: {
    color: 'white',
    fontSize: 'min(2.5vw, 12px',
    fontWeight: 500,
    letterSpacing: '0.33px',
    lineHeight: 'min(3vw, 16px)',
    textTransform: 'uppercase',
  },
};
